module.exports = __webpack_public_path__ + "static/datomic-5a4f39448c788837348064dc4880e2ce.svg";